import React from "react"
import { MenuData } from "../../components/Menu"

import {
	getBusinessTypesLinks,
	businessTypesIconColor,
	businessTypesItemHoverColor,
} from "../../navMenuData/businessTypes"

import TableService from "../../assets/dropdownItemsIcons/TableService"
import Entertainment from "../../assets/dropdownItemsIcons/Entertainment"
import TakeawayOnly from "../../assets/dropdownItemsIcons/TakeawayOnly"
import Canteen from "../../assets/dropdownItemsIcons/Canteen"

import Fastfood from "../../assets/dropdownItemsIcons/Fastfood"
import OtherIcon from "../../assets/dropdownItemsIcons/Other"
import Coffeehouse from "../../assets/dropdownItemsIcons/Coffeehouse"
import {Locales} from "../../../../../localization/types";

export const getData = (locale: Locales): {
	businessTypes: MenuData
} => {
	const businessTypesLinks = getBusinessTypesLinks(locale);

	return {
		businessTypes: {
			id: "businessTypes",
			iconColor: businessTypesIconColor,
			itemHoverColor: businessTypesItemHoverColor,
			items: [
				{
					icon: <TableService />,
					name: "Обслуживание за столиками",
					links: [businessTypesLinks.restaurant, businessTypesLinks.cafe],
				},
				{
					icon: <Entertainment />,
					name: "Развлекательные",
					links: [
						businessTypesLinks.bar,
						businessTypesLinks.pub,
						businessTypesLinks.hookah,
					],
				},
				{
					icon: <Fastfood />,
					name: "Уличная еда",
					links: [businessTypesLinks.fastfood, businessTypesLinks.foodtruck],
				},
				{
					icon: <OtherIcon />,
					name: "Другое",
					links: [businessTypesLinks.publicEvents],
				},
				{
					icon: <Coffeehouse />,
					name: "Кофе и выпечка",
					links: [
						businessTypesLinks.coffeehouse,
						businessTypesLinks.bakery,
						businessTypesLinks.confectionery,
					],
				},
				{
					icon: <Canteen />,
					name: "Столовая и блюда на вес",
					links: [businessTypesLinks.refectory, businessTypesLinks.cookery],
				},
				{
					icon: <TakeawayOnly />,
					name: "Доставка и навынос",
					links: [
						businessTypesLinks.pizzeria,
						businessTypesLinks.sushi,
						businessTypesLinks.darkKitchen,
					],
				},
			],
		},
	}
}